import {Component, Object3D, WonderlandEngine} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {quat2, vec3} from 'gl-matrix';
import {EnemyComponent} from './enemy-component.js';
import {EnemyPrefabs} from './enemy-prefabs.js';
import {playerObject} from './player-component.js';

const tempVec = vec3.create();
const tempVec2 = vec3.create();
const tempQuat2 = quat2.create();

export class EnemySpawner extends Component {
    static TypeName = 'enemy-spawner';

    static onRegister(engine: WonderlandEngine) {
        engine.registerComponent(EnemyComponent);
    }

    /**
     * The delay in seconds before the enemy respawns after it's been killed
     */
    @property.int(8)
    respawnDelay = 8;

    @property.object({required: true})
    enemyPrefabs!: Object3D;

    @property.string('')
    enemyName = '';

    @property.int(1)
    spawnEnemyLevel = 1;

    @property.object({required: true})
    enemyPrefabsObject!: Object3D;

    enemyPrefab: Object3D | null = null;

    start() {
        this.enemyPrefabsObject.getComponent(EnemyPrefabs)!.onPrefabsLoaded.add((o) => {
            this.enemyPrefabs = o;

            const results = this.enemyPrefabs.findByName(this.enemyName);

            if (results.length > 0) {
                this.enemyPrefab = results[0];
                this.enemyPrefab.active = false;
            } else {
                console.error(`Enemy "${this.enemyName}" not found!`);
            }
            this._spawnEnemy();
        });
    }

    private _spawnEnemy() {
        if (!this.enemyName) {
            console.error('No enemy name set!');
            return;
        }
        if (!this.enemyPrefab) {
            console.error('No enemy prefab set!');
            return;
        }

        if (playerObject) {
            playerObject.getPositionWorld(tempVec as number[]);
            this.object.getPositionWorld(tempVec2 as number[]);

            const dist = 25;
            /* If player not close, we don't spawn for performance reasons */
            if (vec3.squaredDistance(tempVec, tempVec2) > dist * dist) {
                /* Try again in a second */
                setTimeout(() => this._spawnEnemy(), 5000);
                return;
            }
        }

        const newEnemy = this.enemyPrefab.clone();
        /* FIXME: Workaround for a bug in clone() where the object is scaled improperly - Fixed in 2024-04-26 */
        newEnemy.setDirty();
        newEnemy.setTransformWorld(this.object.getTransformWorld(tempQuat2));
        newEnemy.active = true;

        const enemyComp = newEnemy.getComponent(EnemyComponent);
        if (!enemyComp) {
            console.error(`Enemy "${this.enemyName}" has no EnemyComponent!`);
            newEnemy.destroy();
            /* Try again in a second */
            setTimeout(() => this._spawnEnemy(), 1000);
            return;
        }
        enemyComp.level = this.spawnEnemyLevel;
        enemyComp.active = true;

        const enemyData = enemyComp.getData();
        enemyData.propertyChanged.add((propName) => {
            if (propName === 'dead' && enemyData.dead) {
                this._activateRespawn();
            }
        });
    }

    private _activateRespawn() {
        setTimeout(() => {
            this._spawnEnemy();
        }, this.respawnDelay * 1000);
    }
}
